import React, { PropTypes } from 'react'

import Interactable from './utility/Interactable'

const getStyles = ({ isHovering }) => ({
  root: {
    display: 'inline-block',
    fontWeight: 700,
    color: '#FFF',
    padding: '10px 16px',
    borderRadius: 4,
    backgroundColor: isHovering ? '#3aa28b' : '#4FC0A7',
    display: 'inline-flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  }
})

const ButtonLink = ({ children, style, ...rest }) => {
  const styles = getStyles(rest)

  return (
    <a style={{ ...styles.root, ...style }} {...rest}>
      { children }
    </a>
  )
}

ButtonLink.propTypes = {
  isHovering: PropTypes.bool
}

ButtonLink.defaultProps = {
  isHovering: false
}

export default Interactable(ButtonLink)



// WEBPACK FOOTER //
// ./src/components/ButtonLink.js